/**
 * Report Placeholder Component
 * Placeholder for security reports - to be implemented
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles, Text } from '@fluentui/react-components';
import { DocumentBulletListRegular } from '@fluentui/react-icons';
import { ContentCard } from '../../../components/layout';

const useStyles = makeStyles({
  container: {
    padding: '24px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  header: {
    marginBottom: '24px',
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#323130',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  placeholderContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '64px 24px',
    textAlign: 'center',
  },
  icon: {
    fontSize: '64px',
    color: '#008272',
    marginBottom: '24px',
  },
  message: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#323130',
    marginBottom: '8px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#605e5c',
  },
});

interface ReportPlaceholderProps {
  reportNumber?: string;
  reportName?: string;
}

export const ReportPlaceholder: React.FC<ReportPlaceholderProps> = ({
  reportNumber,
  reportName,
}) => {
  const styles = useStyles();
  const params = useParams();

  // Extract report number from URL if not provided as prop
  const displayNumber = reportNumber || params.reportId || '1';
  const displayName = reportName || `Report ${displayNumber}`;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Text className={styles.title}>
          <DocumentBulletListRegular />
          {displayName}
        </Text>
      </div>

      <ContentCard>
        <div className={styles.placeholderContent}>
          <DocumentBulletListRegular className={styles.icon} />
          <Text className={styles.message}>Report Coming Soon</Text>
          <Text className={styles.subtitle}>
            This report is currently under development. Check back later for updates.
          </Text>
        </div>
      </ContentCard>
    </div>
  );
};

export default ReportPlaceholder;
